module.exports = __webpack_public_path__ + "img/cleandar-clock-primary.ee20d4a.png";